module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("gKROj"))).then(() => parcelRequire('d0iPb'));